export const MHCRoles = {
  ACCOUNTS_OFFICER: "AEMMA_ACCOUNTS_OFFICER",
  ADMIN: "AEMMA_ADMIN",
  AUDIT: "AEMMA_AUDIT",
  LOGISTICS: "AEMMA_LOGISTICS",
  SALES_OFFICER: "AEMMA_SALES_OFFICER",
  TREASURER: "AEMMA_TREASURER",
  UTILITY_BOD_MANAGER: "AEMMA_UTILITY_BOD_MANAGER",
};

// Highest-to-lowest precedence used to pick the single role to display for a user.
export const MHCRolePriority: string[] = [
  MHCRoles.ADMIN,
  MHCRoles.TREASURER,
  MHCRoles.ACCOUNTS_OFFICER,
  MHCRoles.SALES_OFFICER,
  MHCRoles.LOGISTICS,
  MHCRoles.AUDIT,
  MHCRoles.UTILITY_BOD_MANAGER,
];

export const MHCRoleLabels: Record<string, string> = {
  [MHCRoles.ADMIN]: "Administrator",
  [MHCRoles.TREASURER]: "Treasurer",
  [MHCRoles.ACCOUNTS_OFFICER]: "Accounts Officer",
  [MHCRoles.SALES_OFFICER]: "Sales Officer",
  [MHCRoles.AUDIT]: "Audit",
  [MHCRoles.LOGISTICS]: "Logistics",
  [MHCRoles.UTILITY_BOD_MANAGER]: "Utility BOD Manager",
};

// Returns the highest-precedence MHC role the user holds, or undefined.
export const getPrimaryMHCRole = (
  roles: string[] | null | undefined,
): string | undefined => {
  if (!roles?.length) {
    return undefined;
  }
  return MHCRolePriority.find((role) => roles.includes(role));
};

// Returns the display label for the user's highest-precedence MHC role, or "".
export const getPrimaryMHCRoleLabel = (
  roles: string[] | null | undefined,
): string => {
  const primaryRole = getPrimaryMHCRole(roles);
  return primaryRole ? MHCRoleLabels[primaryRole] ?? "" : "";
};
